import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import { Blade } from '../shared/Blade'
import SydButton from '../../../../../commonDesign/Button'
import { useClientReviewContext } from '../ClientReviewContext'
import { usePolicy } from '../../../../../../hooks/usePolicy'
import OverrideList from './OverrideList'

const useStyles = makeStyles((theme) => ({
  overrides: {
    padding: theme.layout.padding.medium
  },
  actions: {
    padding: theme.layout.padding.medium,
    display: 'flex',
    flexDirection: 'row-reverse',
    borderBottom: '1px solid var(--color-neutral-700)'
  }
}))

function PositionOverridesDetails ({ overrides }) {
  const classes = useStyles()
  const canEditOverrides = usePolicy('billing_edit_overrides')
  const cr = useClientReviewContext()
  if (!overrides) {
    return null
  }

  return (
    <Blade>
      {canEditOverrides ? (
        <div className={classes.actions}>
          <SydButton size='xs' icon='add' onClick={() => cr.dialogs.addPositionOverride()}>Add Position Override</SydButton>
        </div>
      ) : null}
      <div className={classes.overrides}>
        {!overrides?.length ? (
          <div className='__no-content'>
            No Position Overrides
          </div>
        ) : (
          <OverrideList
            overrides={overrides}
            display={a => (
              <span>{a.accountName} &rarr; {a.assetIdentifier}</span>
            )}
          />
        )}
      </div>
    </Blade>
  )
}

PositionOverridesDetails.propTypes = {
  overrides: PropTypes.any
}

export default PositionOverridesDetails
